export default __webpack_public_path__ + "static/media/quota-container.6889ddbb.svg";